import { PunctualityReportRepository } from '@src/main/modules/reports/punctuality/domain/punctuality-report.repository';
import {
  PunctualityDetail,
  PunctualityReportCriteria,
} from '@src/main/modules/reports/shared/domain/report.interface';

export const findDetailedPunctualityReports = async (
  repository: PunctualityReportRepository,
  criteria: PunctualityReportCriteria,
): Promise<PunctualityDetail[]> => await repository.findDetailed(criteria);
